
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import Widget from "../../prefabricated/Widget";
import {
    BBDisableChildren, bbDoesUserHaveAccessToBreachRiskLevelForEntity,
    bbErrorSection, bbFindEntityWithinPortfolioOrSelf,
    isCurrentUserMemberOf
} from "../../../util/bbHelpers";
import React, {useEffect} from "react";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {useDispatch, useSelector} from "react-redux";
import Skeleton from "react-loading-skeleton";
import {fetchRiskCycleReport} from "../../../actions";

const FindingsSummary = ({
    portfolioView = false,
    cycleInView = null,
                         }
    // showVectorRiskScore = false,

    ) => {

    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {entityInView, portfolios, loadingPortfolios, loadingPortfoliosError, selfEntityId} = useSelector(({breachrisk}) => breachrisk);
    // const customer = customers ? customers[customerInView] : null;
    const {authUser} = useSelector(({auth}) => auth);

    const dispatch = useDispatch();

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);
    // const myEntity = portfolios ? portfolios[customerIdToUse] ? portfolios[customerIdToUse].entities ? selfEntityId ? portfolios[customerIdToUse].entities[selfEntityId] : null : null : null : null;


    const lastCycle = myEntity && myEntity.cycles && myEntity.settings && myEntity.settings.last_cycle_id ? myEntity.cycles[myEntity.settings.last_cycle_id] : null;
    const positiveFactors = lastCycle
        ? lastCycle.findings.positive.filter((thing, index, self) =>
        index === self.findIndex((t) => (
            t.definition.id === thing.definition.id
        )))
        : null;
    const negativeFactors = lastCycle
        ? lastCycle.findings.negative.filter((thing, index, self) =>
            index === self.findIndex((t) => (
                t.definition.id === thing.definition.id
            )))
        : null;

    const pastReportView = cycleInView && lastCycle && cycleInView !== lastCycle.id;

    useEffect(()=>{
        if(pastReportView){
            if (cycleInView && myEntity && myEntity.cycles && !myEntity.cycles[cycleInView]) {
                dispatch(fetchRiskCycleReport({
                    customerId: customerIdToUse,
                    cycleId: cycleInView
                }))
            }
        }
    }, [cycleInView])

    const cycleToUsePRV = pastReportView && myEntity && myEntity.cycles && myEntity.cycles[cycleInView] ? myEntity.cycles[cycleInView] : null;
    const positiveFactorsPRV = cycleToUsePRV
        ? cycleToUsePRV.findings.positive.filter((thing, index, self) =>
            index === self.findIndex((t) => (
                t.definition.id === thing.definition.id
            )))
        : null;
    const negativeFactorsPRV = cycleToUsePRV
        ? cycleToUsePRV.findings.negative.filter((thing, index, self) =>
            index === self.findIndex((t) => (
                t.definition.id === thing.definition.id
            )))
        : null;

    const positiveFactorsToUse = pastReportView ? positiveFactorsPRV : positiveFactors;
    const negativeFactorsToUse = pastReportView ? negativeFactorsPRV : negativeFactors;



    // console.log("positiveFactors", positiveFactors, "negativeFactors", negativeFactors)

    // const positiveFactorsNoDuplicates = positiveFactors.filter((thing, index, self) =>
    //         index === self.findIndex((t) => (
    //             t.definition.id === thing.definition.id
    //         ))
    // )
    // const negativeFactorsNoDuplicates = negativeFactors.filter((thing, index, self) =>
    //         index === self.findIndex((t) => (
    //             t.definition.id === thing.definition.id
    //         ))
    // )
    // console.log("positiveFactorsNoDuplicates", positiveFactorsNoDuplicates, "negativeFactorsNoDuplicates", negativeFactorsNoDuplicates)

    const isUserAllowedToSeeDataInThisTable = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel2", entityInView);


    return <Widget styleName={`p-2 animated fadeIn animation-duration-5 dataTile`}>
        <Tooltip disableFocusListener
                 title={"Detailed instances of both positive and negative factors influencing your score."}>
            <InfoSharpIcon style={{fontSize: "20px", marginLeft: "auto", marginTop: 0, zIndex: 5}}
                           className={`text-muted`}/>
        </Tooltip>
        <div className="row"  id={"tourReportFindingsSummary"}>
            <div className={"col-12"}>
                <h1 className={"text-center"}>Factors Influencing Your BreachRisk™ Score</h1>
                <p className={"text-center"}>Your BreachRisk™ Score is primarily based on the most dangerous threats we find, and the amount of time those threats have been present.<br/>
                The following factors can also help you understand how your score is being influenced so that you can make the right business decisions.</p>


            </div>
        </div>
        <div className="row">
            <div className={"col-12"}>
                <BBDisableChildren
                    isDisabled={isUserAllowedToSeeDataInThisTable}
                    brLevelRequired= {"infoLevel2"}
                    blurLevel={(isCurrentUserMemberOf(authUser, "admin")|| isCurrentUserMemberOf(authUser, "staff")) ? 0 : 5}
                    portfolioView={portfolioView}
                >
                    {!portfolios || loadingPortfolios[customerIdToUse] ?
                        <Skeleton count={5}/>
                        : !myEntity || loadingPortfoliosError[customerIdToUse] ?
                            <div className={"text-center"}>
                                {bbErrorSection("80px")}
                            </div>
                            :
                            <div className="row">
                                <div className={"col-6"}>
                                    <h3 className={"text-center"}>Positive Factors</h3>
                                    <hr/>
                                        {positiveFactorsToUse && positiveFactorsToUse.length > 0
                                            ? <ol>{positiveFactorsToUse.map(f => <li key={`rec_${f.cycle}_${f.id}`}><Tooltip title={f.definition ? f.definition.description : ""}><span>{f.definition ? f.definition.name : ""}. {f.definition && f.definition.recommendation ? <span><strong> Recommendation: </strong><em>{f.definition.recommendation}</em></span> : ""}</span></Tooltip></li>)}</ol>
                                            : <div className={"text-center"}><em>No positive factors detected.</em></div>
                                        }
                                </div>
                                <div className={"col-6"}>
                                    <h3 className={"text-center"}>Aggravating Factors</h3>
                                    <hr/>

                                        {negativeFactorsToUse && negativeFactorsToUse.length > 0
                                            ? <ol>{negativeFactorsToUse.map(f => <li key={`rec_${f.cycle}_${f.id}`}><Tooltip title={f.definition ? f.definition.description : ""}><span>{f.definition ? f.definition.name : ""}. <strong>Recommendation:</strong> <em>{f.definition ? f.definition.recommendation : ""}</em></span></Tooltip></li>)}</ol>
                                            : <div className={"text-center"}><em>No negative factors detected.</em></div>
                                        }

                                </div>
                            </div>
                    }
                </BBDisableChildren>
            </div>

        </div>

    </Widget>
};

export default FindingsSummary;